import { getChatApiRoute } from '@shared/utils/ChatBackendUtils'
import AuthIpcRenderer from '@renderer/ipc/AuthIpc.renderer'

interface ReviseSummaryResponse {
  success: true
  data: { summary: string }
}

/**
 * Revises `currentSummary` on the backend from a prompt. `currentSummary` may be unsaved. Nothing is saved
 * until the caller publishes the returned draft.
 */
export async function reviseAudioNoteSummary(
  noteId: string,
  instruction: string,
  currentSummary: string,
): Promise<string> {
  const token = await AuthIpcRenderer.getAccessToken()
  const response = await fetch(getChatApiRoute(`api/v1/audio-notes/${noteId}/summary/revise`), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ instruction, summary: currentSummary }),
  })

  if (response.status === 403) {
    throw new Error('Editing summaries with a prompt needs a paid plan.')
  }
  if (!response.ok) {
    throw new Error(`Summary revision failed (HTTP ${response.status}).`)
  }

  const body = (await response.json()) as ReviseSummaryResponse
  return body.data.summary
}
